// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProfileSideMenu":"jc_a bia_sv bia_tr bia_wq"};